<template>
  <component :is="iconName" />
</template>

<script>
import sdgIcon1 from '@/assets/sdg-icons/SDG-1.svg?inline'
import sdgIcon2 from '@/assets/sdg-icons/SDG-2.svg?inline'
import sdgIcon3 from '@/assets/sdg-icons/SDG-3.svg?inline'
import sdgIcon4 from '@/assets/sdg-icons/SDG-4.svg?inline'
import sdgIcon5 from '@/assets/sdg-icons/SDG-5.svg?inline'
import sdgIcon6 from '@/assets/sdg-icons/SDG-6.svg?inline'
import sdgIcon7 from '@/assets/sdg-icons/SDG-7.svg?inline'
import sdgIcon8 from '@/assets/sdg-icons/SDG-8.svg?inline'
import sdgIcon9 from '@/assets/sdg-icons/SDG-9.svg?inline'
import sdgIcon10 from '@/assets/sdg-icons/SDG-10.svg?inline'
import sdgIcon11 from '@/assets/sdg-icons/SDG-11.svg?inline'
import sdgIcon12 from '@/assets/sdg-icons/SDG-12.svg?inline'
import sdgIcon13 from '@/assets/sdg-icons/SDG-13.svg?inline'
import sdgIcon14 from '@/assets/sdg-icons/SDG-14.svg?inline'
import sdgIcon15 from '@/assets/sdg-icons/SDG-15.svg?inline'
import sdgIcon16 from '@/assets/sdg-icons/SDG-16.svg?inline'
import sdgIcon17 from '@/assets/sdg-icons/SDG-17.svg?inline'

export default {
  name: 'sdg-icon',
  components: {
    sdgIcon1,
    sdgIcon2,
    sdgIcon3,
    sdgIcon4,
    sdgIcon5,
    sdgIcon6,
    sdgIcon7,
    sdgIcon8,
    sdgIcon9,
    sdgIcon10,
    sdgIcon11,
    sdgIcon12,
    sdgIcon13,
    sdgIcon14,
    sdgIcon15,
    sdgIcon16,
    sdgIcon17,
  },
  props: {
    sdg: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconName() {
      return 'sdgIcon' + this.sdg
    },
  },
}
</script>
